let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("emEdI")).then(() => parcelRequire('4bz8w'));